<div class="wrapper">
  <!--<app-loader></app-loader>-->
  <div id="map"></div>
  <app-cercador-switch [setLlistaIncidencies]="alertesVisiblesFeatures" [infowindow]="infowindow"
  [map]="map" (searchEmitter)="searchPlace($event)" (directionsEmitter)="onEventDirections($event)"></app-cercador-switch>
  <app-trafic [events]="updateSubject.asObservable()" (trafficEmitter)="toggleTraffic($event)"></app-trafic>
  <app-botons [map]="map"></app-botons>
  <a href="https://maps.google.com/maps?ll=40.38937,-3.511634&z=7&t=m&hl=es-ES&gl=US&mapclient=apiv3" class="google-logo" title="Abre esta zona en Google Maps (se abre en una nueva ventana)">
    <img src="assets/img/googleLogo.png" width="75px" alt="">
  </a>
</div>
